<template>
    <div id="app">
        <div class="section">
            <h3>img src="../../../assets/images/logo.png"</h3>
            <img style="height: 80px;" alt="Vue logo" src="../../../assets/images/logo.png">
        </div>

        <div class="section borderTop">
            <h3>{{loader}} <i>- kein Component import notwendig, einfach die Tags verwenden</i></h3>
            <dot-loader></dot-loader>
        </div>

        <div class="section borderTop borderBottom">
            <h3>{{breadCrumb}}</h3>
            <BreadCrumb/>
        </div>

        <div class="section borderBottom">
            <h3>{{infoBubble}}</h3>
            <h5>props: {value: <i>String</i>,
                color:<i>'pink' or 'blue'</i>,
                isFilled: <i>Boolean</i>,
                icon: <i>String</i>,
                iconColor: <i>String</i>,
                @click}</h5>
            <div class="flex">
                <div><InfoBubble value="STERN.de" color="pink"></InfoBubble>
                    <InfoBubble value="STERN.de" color="pink" :isFilled="true"></InfoBubble>
                    <br/>
                    <InfoBubble value="STERN.de" color="blue"></InfoBubble>
                    <InfoBubble value="STERN.de" color="blue" :isFilled="true"></InfoBubble>
                    <br/>
                    <div>mit clickEvent</div>
                    <InfoBubble value="STERN.de" color="blue" icon="icon-apply" @click="alert('infobubble wurde geklickt')"></InfoBubble>
                </div>
                <div style="margin-left: 10em;">
                    {{infoBubbleDesc}}
                    <br/><br/><br/>
                    {{infoBubbleClick}}
                </div>
            </div>
        </div>


        <br/><br/>
        <h1>Inputs</h1>
        <div class="section">
            <h3>{{input}}</h3>
            <h5>props: {label:<i>String</i>, placeholder:<i>String</i>, value:<i>String</i>,
                icon: <i>String</i>,
                iconColor: <i>String</i>,
                iconBorder:<i>Boolean</i>
                iconSize:<i>String</i>, width:<i>String</i>, disabled:<i>Boolean</i>, @click, @input(value), @enter}</h5>
            <div class="flex">
                <div>
                    <InputDetail label="label" placeholder="placeholder" value="value"
                                 icon="icon-device-desktop" :iconBorder="true"
                                 @enter="alert('enter')" @click="alert('inputDetail icon clicked')" @input="getValue"></InputDetail>
                    <br/>
                    <InputDetail label="label" placeholder="placeholder" value="value" :disabled="true"></InputDetail>
                </div>
                <div>
                    {{inputDesc}} <br/><br/><br/>
                    {{inputDescDisabled}}
                </div>
            </div>

        </div>
        <div class="section borderTop">
            <h3>{{inputFloat}} -- <span style="font-size: 15px;">benötigt 'required' property um richtig zu funktionieren</span> </h3>
            <h5>props: {
                label: <i>String</i>,
                value: <i>String</i>,
                icon: <i>String</i>,
                iconColor: <i>String</i>,
                iconBorder: <i>Boolean</i>,
                iconSize: <i>String</i>,
                width: <i>String</i>,
                disabled: <i>Boolean</i>,@input(value), @click, @enter},required:<i>Boolean</i></h5>
            <div class="flex">
                <div>
                    <inputFloatLabel label="label" @enter="alert('enter')" @input="searchValueChanged" value="label" :icon-border="true" icon="icon-device-desktop" @click="alert('input float label icon click')" :required="true"></inputFloatLabel>
                </div>
                <div>{{inputFloatDesc}}</div>
            </div>


        </div>
        <div class="section borderTop">
            <h3>{{inputSearch}}</h3>
            <div class="flex">
                <div>
                    <InputSearch v-model="searchValue" @input="searchValueChanged" @click="alert('clicked: ' + searchValue)"></InputSearch>
                </div>
            </div>


        </div>
        <div class="section borderTop">
            <h3>{{datepicker}}</h3>
            <DatePicker style="width: 200px" @close="datePickerClosed"></DatePicker>
        </div>

        <div class="section borderTop">
            <h3>{{select}}</h3>
            <h5>props: {
                placeholder: <i>String</i>,
                disabled: <i>Boolean</i>,
                label: <i>String</i>,
                width: <i>String</i>,
                initial: <i>String</i>,
                options: <i>Array</i>},required:<i>Boolean</i></h5>
            <SelectDetail class="input" v-model="adSpecial" label="AdSpecial" :options="this.adSpecialOptions"
                          initial="DynamicAd" :disabled=false></SelectDetail>
        </div>

        <div class="section borderTop borderBottom">
            <h3>{{cbxBig}}</h3>
            <h5>props: {
                disabled: <i>Boolean</i>,
                id: <i>String</i>,
                label: <i>String</i>,
                labelDetail: <i>String</i>,
                initial: <i>String</i>,
                @change}</h5>
            <XXLCheckbox @change="alert('xxlBox changed')" labelDetail="Platzierung" label="Run of Channel"
                         initial=true></XXLCheckbox>
        </div>


        <br/><br/><br/>
        <div class="section">
            <h3>{{accordion}}</h3>
            <h5>props: {content: <i>Array</i>,,
                multiple: <i>{
                type: Boolean,
                default: false}</i>}</h5>
            <Accordion @accordionAction="addElement" @copyElement="copyElement" @deleteElement="deleteElement"
                       @addElement="addElement" :content="this.exampleData" :multiple=true></Accordion>
        </div>

        <div class="section borderTop">
            <h3>{{button}}</h3>
            <h5>props: {
                title*: <i>String</i>,
                to: <i>String</i>,
                type*: <i>String</i>,
                icon: <i>String</i>,
                textColor: <i>String</i>,
                bgColor: <i>String</i>,
                fontWeight: <i>String</i>, @click
                }</h5>
            <AdaButton icon="icon-add" @click="copyElement" type="fullWidthButton"
                       title="Neues Medium"></AdaButton>
        </div>

        <div class="section borderTop">
            <h3>{{dialog}}</h3>
            <button v-on:click="click">Open Dialog</button>
            <Dialog :has-backdrop="true" :show="showDialog" @close="dialogClosed" :show-close-button="true">
                <h2>
                    Dialog Content
                </h2>
            </Dialog>
        </div>

        <div class="section borderTop">
            <h3>{{confirm}}</h3>
            <h5>props: {
            show: <i>Boolean</i>,
            title: <i>String (default: Engagement Tool)</i>,
            closeable: <i>Boolean (default: true)</i>,
            options: <i>Object {confirm: {title,icon}, cancel:{title, icon}}</i>, @onok, @oncancel, @close
            }</h5>
            <button v-on:click="showConfirm = true">Open Confirm</button>
            <div>{{confirmDesc}}</div>
            <Confirm title="Delete Medium" :show="showConfirm" @close="showConfirm = false;"
                     @onok="alert('OK gedrückt')" @oncancel="alert('Verworfen gedrückt')" :options="buttonOptions">
                <p>das ist ein ganz elna ger text mit wsuper vielen rechtshcriebfehlenr. Punkt aus Ende.</p>
                <p>das ist ein ganz elna ger text mit wsuper vielen rechtshcriebfehlenr. Punkt aus Ende.</p>
            </Confirm>
        </div>

        <div class="section borderTop">
            <h3>{{barChart}}</h3>
            <h5>props: {
                title: <i>String</i>,
                data: <i>Array</i>,
                labels: <i>Array</i>
                }</h5>
            <BarChart title="Interaktionen" :labels="['INTERNE KLICKS', 'EXTERNE KLICKS', 'MOUSEOVER', 'SONSTIGE']" :data="[260, 70, 230, 160]" type="small"></BarChart>
        </div>

        <div class="section borderTop">
            <h3>{{pieChart}}</h3>
            <h5>props: {
                title: <i>String</i>,
                data: <i>Array</i>,
                labels: <i>Array</i>,
                centerTitle: <i>String</i>,
                centerText: <i>String</i>
                }</h5>
            <PieChart :labels="['Beriech A', 'Bereich B']" :data="[1.75, 0.63]" title="Gesamt-Klickrate" center-title="Gesamt" center-text="2,38%"></PieChart>
        </div>

        <div class="section borderTop">
            <h3>{{gaugeChart}}</h3>
            <h5>props: {
                value: <i>Number</i>,
                max-value: <i>Number</i>,
                text: <i>String</i>,
                details: <i>String</i>
                }</h5>
            <GaugeChart :value="8.3" :max-value="10" text="&empty; 8,3 s" details="Heavy User (> 10s)"></GaugeChart>
        </div>



    </div>
</template>

<script>
    import Dialog from "../../../components/dialog/Dialog";
    import DatePicker from "../../../components/datePicker/DatePicker";
    import Accordion from "../../../components/accordion/Accordion";
    import AdaButton from "../../../components/buttons/AdaButton";
    import SelectDetail from "../../../components/inputs/SelectDetail";
    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import InputDetail from "../../../components/inputs/InputDetail";
    import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
    import InfoBubble from "../../../components/inputs/InfoBubble";
    import XXLCheckbox from "../../../components/inputs/XXLCheckbox";
    import BarChart from "../../../components/charts/BarChart";
    import PieChart from "../../../components/charts/PieChart";
    import GaugeChart from "../../../components/charts/GaugeChart";
    import InputSearch from "../../../components/inputs/InputSearch";
    import Confirm from "../../../components/dialog/Confirm";

    const exampleData2 = [
        {
            id: 1,
            active: true,
            itemComponentName: "TabExample",
            itemComponentProps: {name: "tester"},
            title: 'BLABLA',
            icon: 'icon-device-desktop'
        },
        {
            id: 2,
            active: false,
            itemComponentName: "TabExample",
            itemComponentProps: {name: "tester"},
            title: 'Accordion',
            icon: 'icon-device-desktop'
        },
        {
            id: 3,
            active: false,
            itemComponentName: "TabExample",
            itemComponentProps: {name: "tester"},
            title: `NANANANA`,
            icon: 'icon-device-desktop'
        }
    ];

    export default {
        name: 'BlaBlaBla',
        components: {
            Confirm,
            InputSearch,
            XXLCheckbox,
            InfoBubble,
            InputFloatLabel,
            InputDetail,
            BreadCrumb,
            SelectDetail,
            AdaButton,
            Accordion,
            Dialog,
            DatePicker,
            BarChart,
            PieChart,
            GaugeChart
        },
        data: function () {
            return {
                blabla: "<BlaBla />",
                breadCrumb: "<BreadCrumb />",
                dialog: "<Dialog />",
                confirm: "<Confirm />",
                barChart: "<BarChart />",
                pieChart: "<PieChart />",
                gaugeChart: "<GaugeChart />",
                datepicker: "<DatePicker />",
                select: "<SelectDetail />",
                accordion: "<Accordion />",
                button: "<AdaButton />",
                input: "<InputDetail />",
                inputDesc: "<InputDetail label=\"label\" placeholder=\"placeholder\" value=\"value\"\n" +
                    "                                 icon=\"icon-device-desktop\" :iconBorder=\"true\"\n" +
                    "                                 @click=\"alert('inputDetail icon clicked')\"></InputDetail>",
                inputDescDisabled: "<InputDetail label=\"label\" placeholder=\"placeholder\" value=\"value\" :disabled=\"true\"></InputDetail>",
                inputFloat: "<InputFloatLabel />",
                inputFloatDesc: "<inputFloatLabel label=\"label\" @enter=\"alert('enter')\" @input=\"getValue\" value=\"label\" " +
                    "icon-border=\"true\" icon=\"icon-device-desktop\" @click=\"alert('input float label icon click')\" :required=\"true\"></inputFloatLabel>",
                infoBubble: "<InfoBubble />",
                infoBubbleDesc: "<InfoBubble value=\"STERN.de\" color=\"pink\" :isFilled=\"true\"></InfoBubble>",
                infoBubbleClick: "<InfoBubble value=\"STERN.de\" color=\"blue\" icon=\"icon-apply\" @click=\"alert('infobubble wurde geklickt')\"></InfoBubble>",
                cbxBig: "<XXLCheckbox />",
                loader: "<dot-loader></dot-loader>",
                inputSearch: "<InputSearch />",
                confirmDesc: "<Confirm title=\"Delete Medium\" :show=\"showConfirm\" @close=\"showConfirm = false;\"\n" +
                    "                     @onok=\"alert('OK gedrückt')\" :options=\"buttonOptions\">\n" +
                    "                <p>das ist ein ganz elna ger text mit wsuper vielen rechtshcriebfehlenr. Punkt aus Ende.</p>\n" +
                    "                <p>das ist ein ganz elna ger text mit wsuper vielen rechtshcriebfehlenr. Punkt aus Ende.</p>\n" +
                    "            </Confirm>",
                showDialog: false,
                showConfirm: false,
                range: {
                    start: {},
                    end: {}
                },
                adSpecial: '',
                adSpecialOptions: [
                    {text: 'Dynamic Billboard', value: 1},
                    {text: 'DynamicAd', value: 2}
                ],
                exampleData: exampleData2,
                searchValue: ''
            }
        },
        methods: {
            click: function () {
                this.showDialog = true;
            },
            dialogClosed: function () {
                this.showDialog = false;
            },
            datePickerClosed: function (range) {
                this.range = range;
            },
            copyElement: function () {
                this.$noty.success("Hello world!");
            },
            deleteElement: function () {
                console.log('deleteElement');
            },
            addElement: function () {
                console.log('addElement');
            },
            alert: function (str) {
                this.$noty.success(str);
            },
            getValue: function(val){
                this.alert(val);
            },
            searchValueChanged: function (val) {
                this.alert(val);
            }
        }
    }
</script>

<style scoped>
    .section {
        margin-top: 1em;
        margin-bottom: 1em;
    }

    .borderTop {
        border-top: 1px solid #cacaca;
    }

    .borderBottom {
        border-bottom: 1px solid #cacaca;
        padding-bottom: 1em;
    }

    .flex {
        display: flex;
        flex-flow: row;
    }

    .section i {
        font-weight: 500;
    }
</style>